import React, { FC } from 'react'
import { StyleProp, TextStyle } from 'react-native'

import { colors, Icon } from '@zet/design-system'
import { Input } from '@zet/design-system/input'
import { Stack } from '@zet/design-system/layout'
import { B1, B2, B5 } from '@zet/design-system/typography'

interface TextInputProps {
  label?: string
  placeholder?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  value?: string
  errorMessage?: string
  isRequired?: boolean
  isEditable?: boolean
  iconLeft?: 'string'
  iconRight?: React.ReactNode
  style?: StyleProp<TextStyle>
  disabled?: boolean
  inputMode?:
    | 'text'
    | 'numeric'
    | 'decimal'
    | 'email'
    | 'tel'
    | 'search'
    | 'url'
  keyboardType?:
    | 'default'
    | 'email-address'
    | 'numeric'
    | 'phone-pad'
    | 'decimal-pad'
  maxLength?: number
  pointerEvents?: 'auto' | 'none' | 'box-none' | 'box-only'
  autoCapitalize: 'none' | 'sentences' | 'words' | 'characters' | undefined
}

export const TextInput: FC<TextInputProps> = ({
  label,
  placeholder,
  onChange = () => null,
  onBlur,
  value,
  errorMessage,
  isRequired,
  isEditable = true,
  iconLeft,
  iconRight,
  style,
  disabled = false,
  inputMode,
  keyboardType,
  maxLength,
  pointerEvents = 'auto',
  autoCapitalize,
}) => {
  return (
    <Stack>
      {label && (
        <B2 className={`text-grays-80 mb-1`}>
          {label}
          {isRequired && <B1 className="text-error-100 ml-1"> *</B1>}
        </B2>
      )}
      <Input
        placeholder={placeholder}
        onBlur={onBlur}
        onChangeText={onChange}
        style={style}
        value={value}
        maxLength={maxLength}
        intent={errorMessage ? 'error' : 'primary'}
        type={errorMessage ? 'error' : 'primary'}
        isEditable={isEditable}
        noIconPadding={false}
        iconLeft={
          iconLeft ? <Icon type={iconLeft} color={colors.grays[70]} /> : null
        }
        inputMode={inputMode}
        keyboardType={keyboardType}
        iconRight={iconRight}
        disabled={disabled}
        pointerEvents={pointerEvents}
        placeholderTextColor={'#A5AFC3'}
        className="font-[Graphie-SemiBold] leading-5"
        autoCapitalize={autoCapitalize}
      />
      {errorMessage ? (
        <Stack className="mt-2">
          <B5 className="text-error-100">{errorMessage}</B5>
        </Stack>
      ) : null}
    </Stack>
  )
}
